@import '../../scss/mixin';

.actions {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: ease-in-out 350ms;
  transition-property: opacity;
}

.action {
  @include btn();
  height: 40px;
  padding: 0px 16px 0px 12px;
  gap: 8px;
  border-radius: 100px;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.06;
  letter-spacing: -0.24px;
  border: 1px solid #F2EFEB;

  background: #FFF;
  color: #3E3F41;

  &:hover {
    border-color: #3E3F41;
  }

  svg {
    display: flex;
    width: 24px;
    height: 24px;
    padding: 4px;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
}

.back {
  @include btn();
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--llm-color-base-900);
  color: var(--llm-color-neutral-100);

  svg {
    width: 20px;
    height: 20px;
    position: relative;
    z-index: 2;
  }
}
